// extracted by mini-css-extract-plugin
export default {"sidebarnavigator":"sidebarnavigator_b2cd848d6f1984a4638b","container":"container_d3d37b7c53a7c6399f18"};